import styled from 'styled-components';

import Checkbox from 'components/common/Checkbox';

export const Row = styled.div`
  align-items: start;
  display: flex;
  gap: 1.6rem;
  margin: 3.2rem 0 1.6rem 0;
`;

export const ExperienceContainer = styled.div`
  align-items: start;
  display: flex;
  gap: 0.8rem;
  width: 100%;

  & > div:nth-child(2) {
    margin-top: 2.4rem;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: start;
  margin-bottom: 3.2rem;
`;

export const StyledCheckbox = styled(Checkbox)`
  & > div:nth-child(2) {
    ${({ theme }) => theme.new.typography.p5};
    color: ${({ theme }) => theme.new.colors.neutral900};
  }
`;
